import React from "react";
import { Link, useNavigate } from "react-router-dom"; // Falls du React Router verwendest
import "./Footer.css"; // Dein CSS für das Styling
import logo from './../../images/moon.png'; // Füge dein Logo hinzu
import MlLogo from './../../images/mllogo1.png'; // Füge dein Logo hinzu

const Footer = () => {
  const navigate = useNavigate();

  // Funktion zum Navigieren und Scrollen nach oben
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer-container">
      {/* Hauptinhalt */}
      <div className="footer-content">
        {/* Logo-Sektion */}
        <div className="footer-section logo-section">
          <img src={logo} alt="Moon Lounge Mond" className="footer-logo" />
          <img src={MlLogo} alt="Moon Lounge Logo" className="footer-logo1" />
        </div>

        {/* Nützliche Links */}
        <div className="footer-section useful-links">
          <h4>Nützliche Links</h4>
          <ul>
            <li>
              <a
                href="https://q-tech.dev"
                className="footer-link"
                target="_blank"
                rel="noreferrer"
              >
                Q-Tech Dev
              </a>
            </li>
            <li>
              <a href="https://menu-software.de" className="footer-link">
                Menu Software
              </a>
            </li>
          </ul>
        </div>

        {/* Social Media Icons */}
        <div className="footer-section social-media">
          <h4>Folge uns</h4>
          <a
            href="https://www.instagram.com/moon.lounge0711/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>

      {/* Datenschutz und Impressum */}
      <div className="footer-links">
        <button onClick={() => handleNavigation("/datenschutz")}>Datenschutz</button>
        <button onClick={() => handleNavigation("/impressum")}>Impressum</button>
      </div>

      {/* Footer-Bottom */}
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Moon Lounge. Alle Rechte
          vorbehalten.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
